import React, { useState } from "react";
import "../CSS/Header.css";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../Assets/logo_transparent.png";

const Header = () => {
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();

  const handleToggle = () => {
    setMenu((prev) => !prev);
  };
  return (
    <>
      <header className="header_wrapper">
        <div className="container">
          <nav aria-label="Main navigation">
            <div className="nav_container">
              <div className="logo_container flex flex_center justify_center">
                <img src={Logo} alt="Syncnode" />
              </div>
              <div className={`nav_links ${menu ? "nav_open" : ""}`}>
                <ul>
                  <li>
                    <NavLink
                      to="/"
                      onClick={() => {
                        setMenu(false);
                      }}
                    >
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/about"
                      onClick={() => {
                        setMenu(false);
                      }}
                    >
                      About
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/pricing"
                      onClick={() => {
                        setMenu(false);
                      }}
                    >
                      Pricing
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/contact"
                      onClick={() => {
                        setMenu(false);
                      }}
                    >
                      Contact Us
                    </NavLink>
                  </li>
                  <li>
                    <button
                      className="header_btn"
                      onClick={() => {
                        navigate("/login");
                        setMenu(false);
                      }}
                    >
                      Login
                    </button>
                  </li>
                  <li>
                    <button
                      className="header_btn"
                      onClick={() => {
                        navigate("/register");
                        setMenu(false);
                      }}
                    >
                      Register
                    </button>
                  </li>
                </ul>
              </div>
              <div
                className={`burger ${menu ? "nav_active" : ""}`}
                onClick={handleToggle}
              >
                <span className="burger_line"></span>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
